import { Button, TextInput } from 'components/common'
import { FILTER_FIELD_ECOM_PRICING } from 'components/orderManagement'
import { useQuery } from 'hooks'
import { useForm } from 'react-hook-form'
import { CustomObject } from 'types/common'
import { ECOM_PRICING_FORM_FIELDS } from 'utils/constants'
import { filterEmptyValues } from 'utils/helpers'

const { BARCODE, BASE_PRICE, CLUSTER } = ECOM_PRICING_FORM_FIELDS

const EcomPricingFilters = ({
  toggleFilterForm,
}: {
  toggleFilterForm: () => void
}) => {
  const { getQuery, removeQuery, setMultipleQueries } = useQuery()
  const filters = getQuery(FILTER_FIELD_ECOM_PRICING)

  const { register, handleSubmit, reset } = useForm({
    defaultValues: filters,
  })

  const onFilterApply = (data: CustomObject) => {
    if (data?.[BARCODE.key] === 'NONE') {
      delete data[BARCODE.key]
    }

    if (data?.[BASE_PRICE.key] === 'NONE') {
      delete data[BASE_PRICE.key]
    }

    if (data?.[CLUSTER.key] === 'NONE') {
      delete data[CLUSTER.key]
    }

    const filteredData = filterEmptyValues(data)

    if (Object.values(filteredData).length > 0) {
      setMultipleQueries({ [FILTER_FIELD_ECOM_PRICING]: filteredData, page: 1 })
    } else {
      removeQuery(FILTER_FIELD_ECOM_PRICING)
    }

    toggleFilterForm()
  }

  const cancelFilter = () => {
    reset(filters)
    toggleFilterForm()
  }

  return (
    <div className="mt-2 rounded-lg border bg-white px-5 py-3 ">
      <div className="mx-auto max-w-5xl">
        <form onSubmit={handleSubmit(onFilterApply)}>
          <div className="grid grid-cols-2 gap-x-14 gap-y-3 md:grid-cols-3">
            {/* Barcode */}
            <TextInput
              register={register}
              name={BARCODE.key}
              label={BARCODE.label}
            />
            {/* Cluster */}
            <TextInput
              register={register}
              name={CLUSTER.key}
              label={CLUSTER.label}
            />
          </div>
          <div className="my-4 flex gap-5">
            <Button buttonText="Apply Filters" className="w-32" />

            <Button
              buttonText="cancel"
              variant="outline"
              type="button"
              onClick={cancelFilter}
              className="w-32"
            />
          </div>
        </form>
      </div>
    </div>
  )
}

export default EcomPricingFilters
